<template>
  <div class="load-fullscreen">
    <el-main
      v-loading.fullscreen="loading"
      element-loading-background="rgba(122, 122, 122, 0.8)"
    >
      <img class="loading-image" src="@/assets/icons/olsera.png" height="80" />
    </el-main>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue'

const props = defineProps({
  loadPage: {
    type: Boolean,
    default: false
  }
})

const loading = computed(() => {
  return props.loadPage
})
</script>

<style lang="scss">
.el-loading-mask.is-fullscreen {
  z-index: 3000 !important;
  background-color: rgba(39, 39, 39, 0.55) !important;
}
.el-loading-spinner {
  top: 40% !important;
}
.el-loading-spinner .circular {
  width: 145px !important;
  height: 145px !important;
}
.load-fullscreen {
  & .loading-image {
    position: absolute;
    top: 47%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
